export const spfxShowcaseContent = {
	title: 'Interactive SPFx Components',
	description: 'Live demos of custom SPFx components — from dynamic list views to intelligent forms',
	overview: {
		title: 'SharePoint Framework (SPFx) Expertise',
		description: 'When Power Platform reaches its limits, SPFx is the answer. I build fully custom SharePoint and Teams experiences that integrate deeply with Microsoft 365 services, your existing infrastructure, and external data sources — all within the familiar Microsoft 365 interface your users already know.',
		capabilities: [
			'Web Parts',
			'List View Command Sets',
			'Application Customizers',
			'Field Customizers',
			'Library Components',
			'PnP Provisioning integration',
			'Microsoft Graph integration',
			'Power Platform connectivity',
			'Microsoft Teams integration'
		],
	},
	features: [
		{
			title: 'Document Library Viewer',
			description: 'Advanced SPFx list view customizations with real-time filtering, sorting, and KPI-style column formatting.',
			technologies: ['SPFx', 'List View Customizer', 'PnPjs', 'React', 'Fluent UI'],
			tab: 'library'
		},
		{
			title: 'Dynamic Form Component',
			description: 'Complex business logic, conditional fields, and real-time validation — all with the flexibility that Power Platform alone can\'t provide.',
			technologies: ['SPFx', 'Web Parts', 'React Forms', 'Validation', 'Power Automate'],
			tab: 'form'
		}
	]
}